import React from "react";
import { Text, StyleSheet } from "react-native";
import { injectIntl } from "react-intl";
import { withTheme } from "styled-components/native";
import { localize } from "cci-utility";
import EasyToast from "./EasyToast";

/* For some reason I was not able to use styled-components with react-native-easy-toast, when solution is found this must be replaced */
const styles = StyleSheet.create({
  bubble: {
    padding: 20,
    paddingTop: 15,
    paddingBottom: 15,
    shadowOffset: { width: 0, height: 0 },
    shadowColor: "#937C7C",
    shadowOpacity: 1.0,
    shadowRadius: 7
  }
});

/**
 * Context API that shares the toast multiple levels down in our component structure.
 */
export const ToastContext = React.createContext({
  success: () => {},
  error: () => {}
});

class Toast extends React.Component {
  constructor() {
    super();

    this.success = this.success.bind(this);
    this.error = this.error.bind(this);
    this.show = this.show.bind(this);
  }

  /**
   * Function called by children components in React Context to show a successful message.
   */
  success(message, values) {
    this.refs.successToast.show(localize(this.props.intl, message, values), 2000);
  }

  /**
   * Function called by children components in React Context to show an error message.
   */
  error(message, values) {
    this.refs.errorToast.show(localize(this.props.intl, message, values), 5000);
  }

  /**
   * Show the server side message, whether success or failure (based on the success property).
   */
  show(message) {
    if (message.success === true) {
      this.success(message);
    } else {
      this.error(message);
    }
  }

  render() {
    const { children, theme } = this.props;

    return (
      <React.Fragment>
        {/* Toast styling for success messages */}
        <EasyToast
          ref="successToast"
          positionValue={theme.pagePadding}
          style={[
            styles.bubble,
            {
              backgroundColor: theme.successToast.backgroundColor
            }
          ]}
          textStyle={{
            color: theme.successToast.fontColor
          }}
          {...this.props}
        />

        {/* Toast styling for error messages */}
        <EasyToast
          ref="errorToast"
          positionValue={theme.pagePadding}
          style={[
            styles.bubble,
            {
              backgroundColor: theme.errorToast.backgroundColor
            }
          ]}
          textStyle={{
            color: theme.errorToast.fontColor
          }}
          {...this.props}
        />

        <ToastContext.Provider
          value={{ success: this.success, error: this.error, show: this.show }}
        >
          {children}
        </ToastContext.Provider>
      </React.Fragment>
    );
  }
}

Toast.defaultProps = {
  positionTop: 20,
  position: "top"
};

export default injectIntl(withTheme(Toast));
